var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipCraftThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    zoomAndPan: "magnify",
    viewBox: "0 0 224.87999 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "4c25b02178"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.0390625 L 224.761719 0.0390625 L 224.761719 149.960938 L 0 149.960938 Z M 0 0.0390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6e76b3700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.050781 5 L 167.679688 5 L 167.679688 97 L 63.050781 97 Z M 63.050781 5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ff3ed993d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 166.214844 33.179688 C 165.792969 32.9375 165.339844 32.816406 164.855469 32.816406 C 164.371094 32.816406 163.917969 32.9375 163.5 33.179688 L 139.824219 46.832031 L 139.824219 39.597656 C 139.824219 39.238281 139.757812 38.894531 139.621094 38.5625 C 139.480469 38.230469 139.285156 37.9375 139.03125 37.683594 C 138.777344 37.429688 138.484375 37.230469 138.152344 37.09375 C 137.816406 36.957031 137.472656 36.886719 137.113281 36.886719 L 117.605469 36.886719 C 118.125 36.371094 118.609375 35.824219 119.0625 35.25 C 119.519531 34.675781 119.9375 34.078125 120.320312 33.453125 C 120.703125 32.828125 121.046875 32.183594 121.351562 31.519531 C 121.660156 30.855469 121.925781 30.171875 122.148438 29.476562 C 122.375 28.78125 122.558594 28.074219 122.699219 27.355469 C 122.84375 26.636719 122.941406 25.914062 122.996094 25.183594 C 123.050781 24.453125 123.066406 23.722656 123.035156 22.992188 C 123.003906 22.261719 122.929688 21.535156 122.8125 20.8125 C 122.695312 20.089844 122.535156 19.375 122.332031 18.671875 C 122.128906 17.96875 121.886719 17.277344 121.605469 16.605469 C 121.320312 15.929688 120.996094 15.273438 120.636719 14.636719 C 120.273438 14 119.878906 13.386719 119.441406 12.796875 C 119.007812 12.207031 118.542969 11.644531 118.039062 11.113281 C 117.539062 10.578125 117.007812 10.074219 116.449219 9.601562 C 115.886719 9.132812 115.300781 8.695312 114.6875 8.292969 C 114.078125 7.890625 113.441406 7.527344 112.785156 7.199219 C 112.132812 6.875 111.457031 6.585938 110.769531 6.339844 C 110.078125 6.09375 109.378906 5.886719 108.664062 5.722656 C 107.949219 5.558594 107.226562 5.4375 106.5 5.359375 C 105.769531 5.28125 105.039062 5.246094 104.308594 5.253906 C 103.574219 5.261719 102.84375 5.3125 102.117188 5.40625 C 101.390625 5.5 100.675781 5.636719 99.964844 5.816406 C 99.253906 5.996094 98.554688 6.214844 97.871094 6.476562 C 97.1875 6.738281 96.519531 7.039062 95.871094 7.382812 C 95.222656 7.722656 94.597656 8.101562 93.996094 8.515625 C 93.390625 8.929688 92.8125 9.378906 92.265625 9.863281 C 91.714844 10.347656 91.195312 10.859375 90.703125 11.40625 C 90.214844 11.949219 89.761719 12.519531 89.339844 13.121094 C 88.917969 13.71875 88.53125 14.339844 88.183594 14.984375 C 87.835938 15.628906 87.527344 16.292969 87.257812 16.972656 C 86.992188 17.652344 86.761719 18.347656 86.574219 19.054688 C 86.390625 19.761719 86.246094 20.480469 86.144531 21.203125 C 85.605469 20.921875 85.050781 20.6875 84.472656 20.5 C 83.898438 20.308594 83.3125 20.164062 82.710938 20.070312 C 82.113281 19.976562 81.511719 19.929688 80.90625 19.933594 C 80.300781 19.9375 79.699219 19.988281 79.101562 20.089844 C 78.503906 20.191406 77.917969 20.339844 77.34375 20.535156 C 76.769531 20.734375 76.214844 20.976562 75.683594 21.261719 C 75.148438 21.546875 74.640625 21.875 74.160156 22.242188 C 73.679688 22.613281 73.230469 23.019531 72.816406 23.460938 C 72.402344 23.902344 72.027344 24.371094 71.6875 24.875 C 71.351562 25.378906 71.054688 25.90625 70.804688 26.457031 C 70.550781 27.007812 70.34375 27.574219 70.1875 28.15625 C 70.027344 28.742188 69.914062 29.335938 69.851562 29.9375 C 69.789062 30.539062 69.773438 31.144531 69.8125 31.746094 C 69.847656 32.351562 69.929688 32.949219 70.0625 33.539062 C 70.195312 34.132812 70.375 34.707031 70.601562 35.269531 C 70.828125 35.832031 71.097656 36.371094 71.414062 36.886719 L 65.871094 36.886719 C 65.507812 36.886719 65.164062 36.957031 64.832031 37.09375 C 64.5 37.230469 64.203125 37.429688 63.949219 37.683594 C 63.695312 37.9375 63.5 38.230469 63.363281 38.5625 C 63.222656 38.894531 63.15625 39.238281 63.15625 39.597656 L 63.15625 90.15625 C 63.15625 90.515625 63.222656 90.863281 63.363281 91.195312 C 63.5 91.527344 63.695312 91.820312 63.949219 92.074219 C 64.203125 92.328125 64.5 92.523438 64.832031 92.660156 C 65.164062 92.800781 65.507812 92.867188 65.871094 92.867188 L 137.113281 92.867188 C 137.472656 92.867188 137.816406 92.800781 138.152344 92.660156 C 138.484375 92.523438 138.777344 92.328125 139.03125 92.074219 C 139.285156 91.820312 139.480469 91.527344 139.621094 91.195312 C 139.757812 90.863281 139.824219 90.515625 139.824219 90.15625 L 139.824219 82.917969 L 163.503906 96.574219 C 163.925781 96.816406 164.378906 96.9375 164.863281 96.9375 C 165.347656 96.9375 165.800781 96.816406 166.21875 96.574219 C 166.640625 96.332031 166.972656 96 167.214844 95.582031 C 167.457031 95.160156 167.578125 94.707031 167.578125 94.222656 L 167.578125 35.527344 C 167.574219 35.042969 167.453125 34.589844 167.210938 34.171875 C 166.964844 33.75 166.632812 33.421875 166.214844 33.179688 Z M 104.542969 10.671875 C 105.40625 10.671875 106.257812 10.757812 107.101562 10.929688 C 107.945312 11.097656 108.765625 11.347656 109.558594 11.679688 C 110.355469 12.011719 111.109375 12.417969 111.824219 12.898438 C 112.539062 13.375 113.203125 13.921875 113.808594 14.53125 C 114.417969 15.140625 114.957031 15.804688 115.4375 16.519531 C 115.914062 17.234375 116.316406 17.992188 116.644531 18.785156 C 116.972656 19.582031 117.21875 20.402344 117.382812 21.246094 C 117.550781 22.089844 117.632812 22.941406 117.632812 23.800781 C 117.628906 24.664062 117.546875 25.515625 117.375 26.359375 C 117.207031 27.199219 116.957031 28.019531 116.625 28.8125 C 116.296875 29.609375 115.890625 30.363281 115.410156 31.078125 C 114.929688 31.792969 114.386719 32.453125 113.777344 33.0625 C 113.167969 33.667969 112.503906 34.210938 111.789062 34.6875 C 111.070312 35.164062 110.316406 35.566406 109.519531 35.894531 C 108.722656 36.222656 107.902344 36.472656 107.058594 36.640625 C 106.210938 36.804688 105.359375 36.890625 104.5 36.886719 C 103.636719 36.886719 102.785156 36.804688 101.941406 36.632812 C 101.097656 36.464844 100.277344 36.21875 99.480469 35.886719 C 98.683594 35.558594 97.929688 35.152344 97.214844 34.675781 C 96.5 34.195312 95.835938 33.652344 95.226562 33.042969 C 94.617188 32.4375 94.074219 31.773438 93.597656 31.058594 C 93.117188 30.34375 92.714844 29.589844 92.386719 28.792969 C 92.054688 28 91.808594 27.179688 91.640625 26.335938 C 91.472656 25.492188 91.386719 24.640625 91.386719 23.78125 C 91.390625 22.917969 91.472656 22.0625 91.644531 21.21875 C 91.8125 20.375 92.0625 19.554688 92.394531 18.757812 C 92.726562 17.960938 93.132812 17.207031 93.613281 16.492188 C 94.09375 15.773438 94.636719 15.113281 95.25 14.503906 C 95.859375 13.894531 96.523438 13.351562 97.242188 12.875 C 97.960938 12.398438 98.71875 11.992188 99.515625 11.664062 C 100.3125 11.335938 101.132812 11.085938 101.980469 10.921875 C 102.828125 10.753906 103.679688 10.671875 104.542969 10.671875 Z M 91.40625 36.886719 L 90.566406 36.886719 C 90.675781 36.707031 90.785156 36.523438 90.886719 36.339844 Z M 75.21875 31.128906 C 75.21875 30.75 75.257812 30.375 75.328125 30.003906 C 75.402344 29.632812 75.511719 29.273438 75.65625 28.921875 C 75.804688 28.574219 75.980469 28.242188 76.191406 27.925781 C 76.402344 27.613281 76.640625 27.320312 76.910156 27.054688 C 77.175781 26.785156 77.46875 26.546875 77.78125 26.335938 C 78.097656 26.125 78.429688 25.949219 78.78125 25.804688 C 79.128906 25.660156 79.488281 25.550781 79.859375 25.476562 C 80.234375 25.402344 80.609375 25.367188 80.988281 25.367188 C 81.363281 25.367188 81.738281 25.402344 82.113281 25.476562 C 82.484375 25.550781 82.84375 25.660156 83.195312 25.804688 C 83.542969 25.949219 83.875 26.125 84.191406 26.335938 C 84.503906 26.546875 84.796875 26.785156 85.0625 27.054688 C 85.332031 27.320312 85.570312 27.613281 85.78125 27.925781 C 85.992188 28.242188 86.167969 28.574219 86.316406 28.921875 C 86.460938 29.273438 86.570312 29.632812 86.644531 30.003906 C 86.714844 30.375 86.753906 30.75 86.753906 31.128906 C 86.753906 31.503906 86.714844 31.878906 86.644531 32.25 C 86.570312 32.621094 86.460938 32.980469 86.316406 33.332031 C 86.167969 33.679688 85.992188 34.011719 85.78125 34.328125 C 85.570312 34.640625 85.332031 34.933594 85.0625 35.199219 C 84.796875 35.46875 84.503906 35.707031 84.191406 35.917969 C 83.875 36.128906 83.542969 36.304688 83.195312 36.449219 C 82.84375 36.59375 82.484375 36.703125 82.113281 36.777344 C 81.738281 36.851562 81.363281 36.886719 80.988281 36.886719 C 80.609375 36.886719 80.234375 36.851562 79.863281 36.777344 C 79.492188 36.703125 79.128906 36.59375 78.78125 36.449219 C 78.429688 36.304688 78.097656 36.125 77.785156 35.914062 C 77.46875 35.707031 77.179688 35.464844 76.910156 35.199219 C 76.644531 34.929688 76.402344 34.640625 76.191406 34.328125 C 75.984375 34.011719 75.804688 33.679688 75.660156 33.332031 C 75.515625 32.980469 75.40625 32.621094 75.332031 32.25 C 75.257812 31.878906 75.21875 31.503906 75.21875 31.128906 Z M 134.398438 87.445312 L 68.582031 87.445312 L 68.582031 42.3125 L 134.398438 42.3125 Z M 162.148438 89.527344 L 139.824219 76.648438 L 139.824219 53.09375 L 162.148438 40.214844 Z M 82.832031 64.894531 C 82.832031 65.507812 82.863281 66.117188 82.921875 66.726562 C 82.984375 67.335938 83.074219 67.9375 83.195312 68.539062 C 83.3125 69.136719 83.464844 69.730469 83.640625 70.316406 C 83.820312 70.902344 84.027344 71.476562 84.261719 72.042969 C 84.496094 72.605469 84.757812 73.160156 85.046875 73.699219 C 85.335938 74.238281 85.652344 74.761719 85.992188 75.269531 C 86.332031 75.777344 86.695312 76.269531 87.085938 76.742188 C 87.472656 77.214844 87.886719 77.664062 88.320312 78.097656 C 88.753906 78.53125 89.207031 78.941406 89.679688 79.328125 C 90.152344 79.714844 90.644531 80.078125 91.15625 80.417969 C 91.664062 80.757812 92.1875 81.070312 92.730469 81.359375 C 93.269531 81.648438 93.824219 81.90625 94.386719 82.140625 C 94.953125 82.375 95.53125 82.578125 96.117188 82.757812 C 96.703125 82.933594 97.296875 83.082031 97.898438 83.199219 C 98.496094 83.320312 99.101562 83.40625 99.710938 83.46875 C 100.320312 83.527344 100.933594 83.554688 101.546875 83.554688 C 102.15625 83.554688 102.769531 83.523438 103.378906 83.464844 C 103.988281 83.402344 104.589844 83.3125 105.191406 83.191406 C 105.792969 83.070312 106.386719 82.921875 106.972656 82.746094 C 107.558594 82.566406 108.132812 82.359375 108.699219 82.125 C 109.265625 81.890625 109.816406 81.628906 110.355469 81.339844 C 110.894531 81.050781 111.421875 80.734375 111.929688 80.394531 C 112.4375 80.054688 112.929688 79.691406 113.402344 79.300781 C 113.875 78.914062 114.328125 78.503906 114.757812 78.070312 C 115.191406 77.636719 115.601562 77.183594 115.988281 76.710938 C 116.378906 76.234375 116.742188 75.746094 117.082031 75.234375 C 117.421875 74.726562 117.734375 74.203125 118.023438 73.664062 C 118.308594 73.121094 118.570312 72.570312 118.804688 72.003906 C 119.039062 71.4375 119.242188 70.863281 119.417969 70.277344 C 119.597656 69.691406 119.746094 69.097656 119.863281 68.5 C 119.980469 67.898438 120.070312 67.292969 120.128906 66.683594 C 120.1875 66.078125 120.21875 65.464844 120.21875 64.855469 C 120.214844 64.242188 120.183594 63.632812 120.125 63.023438 C 120.0625 62.414062 119.972656 61.8125 119.851562 61.210938 C 119.730469 60.613281 119.582031 60.019531 119.402344 59.433594 C 119.226562 58.847656 119.019531 58.273438 118.785156 57.707031 C 118.546875 57.144531 118.285156 56.59375 117.996094 56.054688 C 117.707031 55.515625 117.390625 54.992188 117.050781 54.484375 C 116.710938 53.972656 116.34375 53.484375 115.957031 53.011719 C 115.566406 52.539062 115.15625 52.085938 114.722656 51.65625 C 114.285156 51.222656 113.832031 50.816406 113.359375 50.425781 C 112.886719 50.039062 112.394531 49.675781 111.882812 49.335938 C 111.375 49 110.847656 48.683594 110.308594 48.398438 C 109.769531 48.109375 109.214844 47.851562 108.648438 47.617188 C 108.082031 47.382812 107.503906 47.179688 106.917969 47.003906 C 106.332031 46.828125 105.738281 46.679688 105.140625 46.558594 C 104.539062 46.441406 103.933594 46.355469 103.324219 46.292969 C 102.714844 46.234375 102.101562 46.207031 101.492188 46.207031 C 100.878906 46.210938 100.269531 46.242188 99.660156 46.304688 C 99.050781 46.363281 98.449219 46.457031 97.847656 46.578125 C 97.25 46.695312 96.65625 46.847656 96.070312 47.027344 C 95.488281 47.203125 94.914062 47.410156 94.347656 47.644531 C 93.78125 47.882812 93.230469 48.144531 92.691406 48.433594 C 92.152344 48.722656 91.628906 49.035156 91.121094 49.375 C 90.613281 49.714844 90.125 50.082031 89.652344 50.46875 C 89.179688 50.855469 88.726562 51.269531 88.296875 51.699219 C 87.863281 52.132812 87.453125 52.585938 87.066406 53.058594 C 86.679688 53.53125 86.316406 54.019531 85.976562 54.53125 C 85.636719 55.039062 85.324219 55.5625 85.035156 56.101562 C 84.746094 56.640625 84.488281 57.191406 84.253906 57.757812 C 84.019531 58.320312 83.8125 58.894531 83.636719 59.480469 C 83.457031 60.066406 83.3125 60.65625 83.191406 61.253906 C 83.070312 61.855469 82.980469 62.457031 82.921875 63.066406 C 82.863281 63.675781 82.832031 64.285156 82.832031 64.894531 Z M 114.789062 64.894531 C 114.789062 65.765625 114.703125 66.625 114.53125 67.476562 C 114.363281 68.332031 114.109375 69.160156 113.777344 69.960938 C 113.441406 70.765625 113.035156 71.527344 112.550781 72.25 C 112.066406 72.972656 111.515625 73.640625 110.898438 74.253906 C 110.285156 74.871094 109.613281 75.417969 108.890625 75.902344 C 108.167969 76.382812 107.402344 76.792969 106.597656 77.125 C 105.796875 77.457031 104.964844 77.707031 104.113281 77.878906 C 103.257812 78.046875 102.398438 78.132812 101.527344 78.132812 C 100.65625 78.132812 99.792969 78.046875 98.941406 77.878906 C 98.085938 77.710938 97.257812 77.457031 96.453125 77.125 C 95.648438 76.792969 94.886719 76.386719 94.160156 75.902344 C 93.4375 75.421875 92.769531 74.871094 92.152344 74.257812 C 91.535156 73.644531 90.988281 72.976562 90.503906 72.253906 C 90.019531 71.53125 89.609375 70.769531 89.273438 69.964844 C 88.941406 69.164062 88.6875 68.335938 88.519531 67.484375 C 88.347656 66.628906 88.261719 65.769531 88.261719 64.898438 C 88.257812 64.03125 88.34375 63.167969 88.511719 62.316406 C 88.679688 61.464844 88.929688 60.632812 89.261719 59.832031 C 89.59375 59.027344 90 58.261719 90.480469 57.539062 C 90.964844 56.816406 91.511719 56.144531 92.125 55.53125 C 92.742188 54.914062 93.410156 54.363281 94.132812 53.878906 C 94.855469 53.394531 95.617188 52.984375 96.421875 52.652344 C 97.222656 52.316406 98.050781 52.0625 98.90625 51.890625 C 99.757812 51.71875 100.621094 51.632812 101.492188 51.628906 C 102.363281 51.632812 103.226562 51.71875 104.078125 51.886719 C 104.933594 52.058594 105.761719 52.308594 106.566406 52.644531 C 107.371094 52.976562 108.136719 53.386719 108.859375 53.871094 C 109.585938 54.355469 110.253906 54.90625 110.871094 55.519531 C 111.488281 56.136719 112.035156 56.804688 112.519531 57.53125 C 113.003906 58.253906 113.414062 59.019531 113.746094 59.820312 C 114.078125 60.625 114.332031 61.457031 114.5 62.308594 C 114.671875 63.164062 114.753906 64.023438 114.753906 64.894531 Z M 94.839844 55.953125 C 94.421875 56.195312 94.089844 56.527344 93.847656 56.945312 C 93.605469 57.363281 93.484375 57.816406 93.484375 58.300781 L 93.484375 71.449219 C 93.484375 71.933594 93.605469 72.386719 93.847656 72.808594 C 94.089844 73.226562 94.421875 73.558594 94.839844 73.800781 C 95.261719 74.042969 95.714844 74.164062 96.199219 74.164062 C 96.683594 74.164062 97.136719 74.042969 97.554688 73.800781 L 108.960938 67.226562 C 109.382812 66.984375 109.710938 66.652344 109.957031 66.234375 C 110.199219 65.816406 110.320312 65.363281 110.320312 64.878906 C 110.320312 64.394531 110.199219 63.941406 109.957031 63.523438 C 109.710938 63.101562 109.382812 62.773438 108.960938 62.53125 L 97.554688 55.953125 C 97.136719 55.710938 96.683594 55.589844 96.199219 55.589844 C 95.714844 55.589844 95.261719 55.710938 94.839844 55.953125 Z M 98.914062 62.996094 L 102.175781 64.894531 L 98.914062 66.757812 Z M 98.914062 62.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -4.84315e-8,
    gradientTransform: "matrix(0.678501, 0, 0, 0.677804, 63.155375, 5.248452)",
    y1: 67.639999,
    x2: 153.901046,
    gradientUnits: "userSpaceOnUse",
    y2: 67.639999,
    id: "e8b17dab80"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 76.098633%, 91.398621%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.548523%, 75.892639%, 91.407776%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 75.686646%, 91.416931%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.447266%, 75.479126%, 91.424561%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.8974%, 75.273132%, 91.433716%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.347534%, 75.065613%, 91.442871%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.797668%, 74.859619%, 91.452026%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.246277%, 74.653625%, 91.459656%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.696411%, 74.447632%, 91.468811%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.14502%, 74.240112%, 91.477966%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.595154%, 74.034119%, 91.487122%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.045288%, 73.828125%, 91.494751%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.495422%, 73.622131%, 91.503906%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.944031%, 73.414612%, 91.513062%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.394165%, 73.208618%, 91.522217%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.842773%, 73.001099%, 91.529846%)",
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.292908%, 72.795105%, 91.539001%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.743042%, 72.589111%, 91.548157%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.193176%, 72.383118%, 91.557312%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.641785%, 72.175598%, 91.564941%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.091919%, 71.969604%, 91.574097%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.542053%, 71.762085%, 91.583252%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.992188%, 71.556091%, 91.592407%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.440796%, 71.350098%, 91.600037%)",
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.89093%, 71.144104%, 91.609192%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.339539%, 70.936584%, 91.618347%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.789673%, 70.730591%, 91.627502%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.239807%, 70.523071%, 91.635132%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.689941%, 70.317078%, 91.644287%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.13855%, 70.111084%, 91.653442%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.588684%, 69.90509%, 91.662598%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.037292%, 69.697571%, 91.670227%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.487427%, 69.491577%, 91.679382%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.937561%, 69.284058%, 91.688538%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.387695%, 69.078064%, 91.697693%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.836304%, 68.87207%, 91.705322%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.286438%, 68.666077%, 91.714478%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.735046%, 68.458557%, 91.723633%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.185181%, 68.252563%, 91.732788%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.635315%, 68.045044%, 91.740417%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.085449%, 67.83905%, 91.749573%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.534058%, 67.633057%, 91.758728%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.984192%, 67.427063%, 91.767883%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.434326%, 67.219543%, 91.775513%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.88446%, 67.01355%, 91.784668%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.333069%, 66.80603%, 91.793823%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.783203%, 66.600037%, 91.802979%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.231812%, 66.394043%, 91.810608%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.681946%, 66.188049%, 91.819763%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.13208%, 65.98053%, 91.828918%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.582214%, 65.774536%, 91.838074%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.030823%, 65.568542%, 91.845703%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.480957%, 65.362549%, 91.854858%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.929565%, 65.155029%, 91.864014%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.3797%, 64.949036%, 91.873169%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.829834%, 64.741516%, 91.880798%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.279968%, 64.535522%, 91.889954%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.728577%, 64.329529%, 91.899109%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.178711%, 64.123535%, 91.908264%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.627319%, 63.916016%, 91.915894%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.077454%, 63.710022%, 91.925049%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.527588%, 63.502502%, 91.934204%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.977722%, 63.296509%, 91.943359%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.426331%, 63.090515%, 91.950989%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.876465%, 62.884521%, 91.960144%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.326599%, 62.677002%, 91.969299%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.776733%, 62.471008%, 91.978455%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.225342%, 62.263489%, 91.986084%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.675476%, 62.057495%, 91.995239%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.124084%, 61.851501%, 92.004395%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.574219%, 61.645508%, 92.01355%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.024353%, 61.437988%, 92.021179%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.474487%, 61.231995%, 92.030334%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.923096%, 61.024475%, 92.03949%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.37323%, 60.818481%, 92.048645%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.821838%, 60.612488%, 92.056274%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.271973%, 60.406494%, 92.06543%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.722107%, 60.198975%, 92.074585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.172241%, 59.992981%, 92.08374%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.62085%, 59.785461%, 92.09137%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.070984%, 59.579468%, 92.100525%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.521118%, 59.373474%, 92.10968%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.971252%, 59.16748%, 92.118835%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.419861%, 58.959961%, 92.126465%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.869995%, 58.753967%, 92.13562%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.318604%, 58.547974%, 92.144775%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.768738%, 58.34198%, 92.153931%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.218872%, 58.13446%, 92.16156%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.669006%, 57.928467%, 92.170715%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.117615%, 57.720947%, 92.179871%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.567749%, 57.514954%, 92.189026%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.016357%, 57.30896%, 92.196655%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.466492%, 57.102966%, 92.205811%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.916626%, 56.895447%, 92.214966%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.36676%, 56.689453%, 92.224121%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.815369%, 56.481934%, 92.23175%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.265503%, 56.27594%, 92.240906%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.714111%, 56.069946%, 92.250061%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.164246%, 55.863953%, 92.259216%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.61438%, 55.656433%, 92.266846%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.064514%, 55.450439%, 92.276001%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.513123%, 55.24292%, 92.285156%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.963257%, 55.036926%, 92.294312%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.413391%, 54.830933%, 92.301941%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.863525%, 54.624939%, 92.311096%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.312134%, 54.417419%, 92.320251%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.762268%, 54.211426%, 92.329407%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.210876%, 54.003906%, 92.337036%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.661011%, 53.797913%, 92.346191%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.111145%, 53.591919%, 92.355347%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.561279%, 53.385925%, 92.364502%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.009888%, 53.178406%, 92.372131%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.460022%, 52.972412%, 92.381287%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.90863%, 52.764893%, 92.390442%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.358765%, 52.558899%, 92.399597%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.808899%, 52.352905%, 92.407227%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.259033%, 52.146912%, 92.416382%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.707642%, 51.939392%, 92.425537%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.157776%, 51.733398%, 92.434692%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.606384%, 51.527405%, 92.442322%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.056519%, 51.321411%, 92.451477%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.506653%, 51.113892%, 92.460632%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.956787%, 50.907898%, 92.469788%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.405396%, 50.700378%, 92.477417%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.85553%, 50.494385%, 92.486572%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.243103%, 50.308228%, 92.381287%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.632202%, 50.12207%, 92.277527%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.865662%, 49.986267%, 91.886902%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.100647%, 49.850464%, 91.497803%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.335632%, 49.714661%, 91.107178%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.570618%, 49.580383%, 90.718079%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.804077%, 49.44458%, 90.327454%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.039062%, 49.308777%, 89.938354%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.272522%, 49.172974%, 89.547729%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.507507%, 49.03717%, 89.15863%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.740967%, 48.901367%, 88.768005%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.975952%, 48.765564%, 88.378906%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.210938%, 48.629761%, 87.988281%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.445923%, 48.495483%, 87.599182%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.679382%, 48.35968%, 87.208557%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.914368%, 48.223877%, 86.819458%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.147827%, 48.088074%, 86.428833%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.382812%, 47.952271%, 86.039734%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.616272%, 47.816467%, 85.649109%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.851257%, 47.68219%, 85.26001%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.084717%, 47.546387%, 84.869385%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.319702%, 47.410583%, 84.480286%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.554688%, 47.27478%, 84.089661%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.789673%, 47.138977%, 83.700562%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.023132%, 47.003174%, 83.309937%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.258118%, 46.868896%, 82.920837%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.491577%, 46.733093%, 82.530212%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.726562%, 46.59729%, 82.139587%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.960022%, 46.461487%, 81.748962%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.195007%, 46.325684%, 81.359863%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.429993%, 46.18988%, 80.969238%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.664978%, 46.054077%, 80.580139%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.898438%, 45.918274%, 80.189514%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.133423%, 45.783997%, 79.800415%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.366882%, 45.648193%, 79.40979%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.601868%, 45.51239%, 79.020691%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.835327%, 45.376587%, 78.630066%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.070312%, 45.240784%, 78.240967%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.303772%, 45.10498%, 77.850342%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.538757%, 44.970703%, 77.461243%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.773743%, 44.8349%, 77.070618%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.008728%, 44.699097%, 76.681519%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.242188%, 44.563293%, 76.290894%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.477173%, 44.42749%, 75.901794%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.710632%, 44.291687%, 75.511169%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.945618%, 44.155884%, 75.12207%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.179077%, 44.020081%, 74.731445%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.414062%, 43.885803%, 74.342346%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.649048%, 43.75%, 73.951721%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.884033%, 43.614197%, 73.562622%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.117493%, 43.478394%, 73.171997%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.352478%, 43.34259%, 72.782898%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.585938%, 43.206787%, 72.392273%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.820923%, 43.07251%, 72.003174%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.054382%, 42.936707%, 71.612549%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.289368%, 42.800903%, 71.22345%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.522827%, 42.6651%, 70.832825%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.757812%, 42.529297%, 70.443726%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.992798%, 42.393494%, 70.053101%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.227783%, 42.259216%, 69.664001%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.461243%, 42.123413%, 69.273376%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.696228%, 41.98761%, 68.884277%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.929688%, 41.851807%, 68.493652%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.164673%, 41.716003%, 68.104553%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.398132%, 41.5802%, 67.713928%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.633118%, 41.444397%, 67.324829%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.868103%, 41.308594%, 66.934204%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.103088%, 41.174316%, 66.545105%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.336548%, 41.038513%, 66.15448%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.571533%, 40.90271%, 65.765381%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.804993%, 40.766907%, 65.374756%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.039978%, 40.631104%, 64.985657%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.273438%, 40.4953%, 64.595032%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.508423%, 40.361023%, 64.205933%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.741882%, 40.22522%, 63.815308%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.976868%, 40.089417%, 63.426208%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.211853%, 39.953613%, 63.035583%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.446838%, 39.81781%, 62.646484%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.680298%, 39.682007%, 62.255859%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.915283%, 39.546204%, 61.86676%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.148743%, 39.4104%, 61.476135%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.383728%, 39.276123%, 61.087036%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.617188%, 39.14032%, 60.696411%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.852173%, 39.004517%, 60.307312%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.087158%, 38.868713%, 59.916687%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.322144%, 38.73291%, 59.527588%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.555603%, 38.597107%, 59.136963%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.790588%, 38.46283%, 58.747864%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.024048%, 38.327026%, 58.357239%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.259033%, 38.191223%, 57.966614%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.492493%, 38.05542%, 57.575989%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.727478%, 37.919617%, 57.18689%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.960938%, 37.783813%, 56.796265%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.195923%, 37.64801%, 56.407166%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.430908%, 37.512207%, 56.016541%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.665894%, 37.37793%, 55.627441%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.899353%, 37.242126%, 55.236816%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.134338%, 37.106323%, 54.847717%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.367798%, 36.97052%, 54.457092%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.602783%, 36.834717%, 54.067993%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.836243%, 36.698914%, 53.677368%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.071228%, 36.564636%, 53.288269%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.306213%, 36.428833%, 52.897644%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.541199%, 36.29303%, 52.508545%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.774658%, 36.157227%, 52.11792%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.009644%, 36.021423%, 51.728821%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.243103%, 35.88562%, 51.338196%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.478088%, 35.751343%, 50.949097%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.711548%, 35.61554%, 50.558472%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.946533%, 35.479736%, 50.169373%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.179993%, 35.343933%, 49.778748%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.414978%, 35.20813%, 49.389648%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.649963%, 35.072327%, 48.999023%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.884949%, 34.936523%, 48.609924%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.118408%, 34.80072%, 48.219299%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.353394%, 34.666443%, 47.8302%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.586853%, 34.53064%, 47.439575%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.821838%, 34.394836%, 47.050476%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.055298%, 34.259033%, 46.659851%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.290283%, 34.12323%, 46.270752%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.525269%, 33.987427%, 45.880127%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.760254%, 33.853149%, 45.491028%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.993713%, 33.717346%, 45.100403%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.228699%, 33.581543%, 44.711304%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.462158%, 33.44574%, 44.320679%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.697144%, 33.309937%, 43.93158%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.930603%, 33.174133%, 43.540955%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.165588%, 33.03833%, 43.151855%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.399048%, 32.902527%, 42.76123%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.634033%, 32.76825%, 42.372131%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.865967%, 32.633972%, 41.984558%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.099426%, 32.499695%, 41.598511%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7a1240370a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93 91 L 194 91 L 194 149.960938 L 93 149.960938 Z M 93 91 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4c25b02178)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.0390625 L 224.878906 0.0390625 L 224.878906 149.960938 L 0 149.960938 Z M 0 0.0390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.0390625 L 224.878906 0.0390625 L 224.878906 149.960938 L 0 149.960938 Z M 0 0.0390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e6e76b3700)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ff3ed993d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e8b17dab80)",
    d: "M 63.15625 5.246094 L 63.15625 96.9375 L 167.578125 96.9375 L 167.578125 5.246094 Z M 63.15625 5.246094 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#12c2e9",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.363488, 132.655178)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 19.308594 -11.011719 C 17.582031 -6.351562 13.691406 -4.589844 10.757812 -4.589844 C 7.855469 -4.589844 4.992188 -6.3125 4.992188 -8.738281 C 4.992188 -9.289062 5.066406 -9.910156 5.285156 -10.535156 L 9.910156 -23.421875 C 10.792969 -25.84375 12.296875 -26.210938 13.179688 -26.210938 C 14.023438 -26.210938 14.609375 -25.695312 14.609375 -24.59375 C 14.609375 -24.082031 14.464844 -23.421875 14.167969 -22.6875 C 14.058594 -22.429688 14.023438 -22.171875 14.023438 -21.914062 C 14.023438 -20.628906 15.269531 -19.566406 16.703125 -19.566406 C 17.988281 -19.566406 19.417969 -20.445312 20.082031 -22.871094 C 20.335938 -23.824219 20.445312 -24.707031 20.445312 -25.476562 C 20.445312 -29.515625 17.253906 -31.863281 13.070312 -31.863281 C 10.390625 -31.863281 6.242188 -30.761719 4.296875 -25.257812 L -0.292969 -12.152344 C -0.699219 -11.011719 -0.917969 -9.765625 -0.917969 -8.664062 C -0.917969 -3.855469 3.488281 0 9.875 0 C 14.976562 0 21.328125 -2.605469 23.605469 -9.800781 C 23.675781 -10.09375 23.714844 -10.351562 23.714844 -10.574219 C 23.714844 -11.855469 22.578125 -12.589844 21.4375 -12.589844 C 20.484375 -12.589844 19.566406 -12.113281 19.308594 -11.011719 Z M 19.308594 -11.011719 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#12c2e9",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.313808, 132.655178)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.027344 -5.984375 L 12.738281 -28.304688 C 12.886719 -28.742188 12.957031 -29.183594 12.957031 -29.550781 C 12.957031 -30.945312 11.636719 -31.863281 10.535156 -31.863281 C 9.140625 -31.863281 8.222656 -31.09375 7.636719 -29.441406 L 0 -7.636719 C -0.292969 -6.792969 -0.441406 -6.019531 -0.441406 -5.25 C -0.441406 -1.871094 2.347656 0 5.578125 0 C 9.066406 0 13.4375 -2.164062 16.003906 -9.800781 C 16.078125 -10.058594 16.117188 -10.316406 16.117188 -10.535156 C 16.117188 -11.710938 15.085938 -12.554688 13.949219 -12.554688 C 13.03125 -12.554688 12.039062 -12.003906 11.527344 -10.644531 C 9.875 -6.242188 7.746094 -4.367188 6.019531 -4.367188 C 5.285156 -4.367188 4.882812 -4.808594 4.882812 -5.359375 C 4.882812 -5.507812 4.957031 -5.761719 5.027344 -5.984375 Z M 5.027344 -5.984375 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#12c2e9",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.555405, 132.655178)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.875 -24.925781 C 11.527344 -24.925781 12.886719 -26.285156 12.886719 -27.972656 C 12.886719 -29.625 11.527344 -30.945312 9.875 -30.945312 C 8.222656 -30.945312 6.863281 -29.625 6.863281 -27.972656 C 6.863281 -26.285156 8.222656 -24.925781 9.875 -24.925781 Z M 4.917969 -6.203125 L 8.957031 -17.730469 C 9.105469 -18.207031 9.289062 -18.722656 9.289062 -19.089844 C 9.289062 -20.703125 8.074219 -21.546875 6.828125 -21.546875 C 5.691406 -21.546875 4.480469 -20.742188 3.890625 -19.015625 C 2.714844 -15.566406 1.175781 -11.195312 0 -7.78125 C -0.21875 -7.046875 -0.515625 -6.058594 -0.515625 -5.433594 C -0.515625 -1.980469 2.347656 0 5.726562 0 C 9.324219 0 13.289062 -2.203125 15.859375 -9.800781 C 15.933594 -10.023438 15.96875 -10.242188 15.96875 -10.460938 C 15.96875 -11.601562 14.867188 -12.296875 13.765625 -12.296875 C 12.773438 -12.296875 11.785156 -11.785156 11.34375 -10.644531 C 9.617188 -5.875 7.671875 -4.367188 6.203125 -4.367188 C 5.359375 -4.367188 4.808594 -4.917969 4.808594 -5.617188 C 4.808594 -5.800781 4.84375 -5.984375 4.917969 -6.203125 Z M 4.917969 -6.203125 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#12c2e9",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.686873, 132.655178)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 20.007812 -10.574219 C 18.832031 -7.5625 16.703125 -5.617188 14.167969 -4.699219 L 14.5 -5.46875 C 15.527344 -8.257812 16.59375 -11.304688 17.621094 -14.132812 C 17.839844 -14.757812 17.949219 -15.382812 17.949219 -16.042969 C 17.949219 -19.015625 15.492188 -21.546875 12.628906 -21.546875 C 11.636719 -21.546875 10.460938 -21.363281 9.65625 -20.703125 C 9.726562 -21.585938 8.515625 -22.28125 7.195312 -22.28125 C 5.984375 -22.28125 4.808594 -21.621094 4.257812 -20.082031 L -4.882812 5.761719 C -5.066406 6.242188 -5.140625 6.644531 -5.140625 7.011719 C -5.140625 8.515625 -3.890625 9.289062 -2.570312 9.289062 C -1.359375 9.289062 -0.148438 8.699219 0.292969 7.34375 L 3.230469 -1.359375 C 4.367188 -0.476562 6.570312 0 9.617188 0 C 16.738281 0 22.0625 -2.828125 24.484375 -9.765625 C 24.59375 -10.09375 24.667969 -10.390625 24.667969 -10.644531 C 24.667969 -11.855469 23.640625 -12.589844 22.539062 -12.589844 C 21.546875 -12.589844 20.445312 -11.96875 20.007812 -10.574219 Z M 5.175781 -6.753906 L 8.113281 -15.269531 C 8.554688 -16.59375 9.507812 -17.214844 10.535156 -17.214844 C 11.417969 -17.214844 12.222656 -16.59375 12.222656 -15.675781 C 12.222656 -15.34375 12.152344 -15.015625 12.039062 -14.648438 C 11.121094 -11.746094 10.09375 -9.03125 9.105469 -6.167969 C 8.699219 -5.066406 7.710938 -4.40625 6.71875 -4.367188 C 5.761719 -4.367188 5.027344 -4.882812 5.027344 -5.910156 C 5.027344 -6.167969 5.066406 -6.460938 5.175781 -6.753906 Z M 5.175781 -6.753906 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8a7b2",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.796379, 134.277632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 19.308594 -11.011719 C 17.582031 -6.351562 13.691406 -4.589844 10.757812 -4.589844 C 7.855469 -4.589844 4.992188 -6.3125 4.992188 -8.738281 C 4.992188 -9.289062 5.066406 -9.910156 5.285156 -10.535156 L 9.910156 -23.421875 C 10.792969 -25.84375 12.296875 -26.210938 13.179688 -26.210938 C 14.023438 -26.210938 14.609375 -25.695312 14.609375 -24.59375 C 14.609375 -24.082031 14.464844 -23.421875 14.167969 -22.6875 C 14.058594 -22.429688 14.023438 -22.171875 14.023438 -21.914062 C 14.023438 -20.628906 15.269531 -19.566406 16.703125 -19.566406 C 17.988281 -19.566406 19.417969 -20.445312 20.082031 -22.871094 C 20.335938 -23.824219 20.445312 -24.707031 20.445312 -25.476562 C 20.445312 -29.515625 17.253906 -31.863281 13.070312 -31.863281 C 10.390625 -31.863281 6.242188 -30.761719 4.296875 -25.257812 L -0.292969 -12.152344 C -0.699219 -11.011719 -0.917969 -9.765625 -0.917969 -8.664062 C -0.917969 -3.855469 3.488281 0 9.875 0 C 14.976562 0 21.328125 -2.605469 23.605469 -9.800781 C 23.675781 -10.09375 23.714844 -10.351562 23.714844 -10.574219 C 23.714844 -11.855469 22.578125 -12.589844 21.4375 -12.589844 C 20.484375 -12.589844 19.566406 -12.113281 19.308594 -11.011719 Z M 19.308594 -11.011719 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8a7b2",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.746699, 134.277632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 18.613281 -10.644531 C 17.214844 -7.046875 15.34375 -4.367188 13.804688 -4.367188 C 13.289062 -4.367188 13.03125 -4.84375 13.03125 -5.359375 C 13.03125 -5.578125 13.070312 -5.875 13.179688 -6.167969 L 15.34375 -12.1875 C 15.566406 -12.921875 15.710938 -13.582031 15.710938 -14.207031 C 15.710938 -17.695312 11.304688 -19.164062 9.25 -19.785156 C 9.359375 -20.082031 9.398438 -20.410156 9.398438 -20.703125 C 9.398438 -22.394531 7.890625 -23.824219 6.242188 -23.824219 C 4.074219 -23.824219 2.789062 -21.914062 2.789062 -19.824219 C 2.789062 -18.90625 3.121094 -17.949219 3.707031 -17.214844 L 1.027344 -9.984375 C 0.953125 -9.691406 0.917969 -9.398438 0.917969 -9.175781 C 0.917969 -7.964844 1.871094 -7.34375 2.898438 -7.34375 C 3.929688 -7.34375 4.992188 -7.929688 5.433594 -9.105469 L 7.488281 -14.609375 C 8.515625 -14.28125 9.875 -14.023438 9.875 -12.773438 C 9.875 -12.589844 9.839844 -12.371094 9.765625 -12.113281 L 8.148438 -7.636719 C 7.855469 -6.792969 7.710938 -6.019531 7.710938 -5.285156 C 7.710938 -2.09375 10.242188 0 13.289062 0 C 17.289062 0 20.925781 -3.5625 23.089844 -9.765625 C 23.164062 -9.984375 23.199219 -10.167969 23.199219 -10.351562 C 23.199219 -11.453125 21.988281 -12.1875 20.8125 -12.1875 C 19.859375 -12.1875 18.941406 -11.746094 18.613281 -10.644531 Z M 18.613281 -10.644531 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8a7b2",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.109693, 134.277632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 23.015625 -12.40625 C 21.988281 -12.40625 20.851562 -11.785156 20.410156 -10.390625 C 18.980469 -5.875 16.667969 -4.367188 15.015625 -4.367188 C 14.390625 -4.367188 14.023438 -4.699219 14.023438 -5.285156 C 14.023438 -5.578125 14.097656 -5.945312 14.207031 -6.351562 L 18.316406 -18.246094 C 18.464844 -18.683594 18.539062 -19.089844 18.539062 -19.457031 C 18.539062 -21.070312 17.214844 -21.914062 15.859375 -21.914062 C 14.832031 -21.914062 13.765625 -21.4375 13.179688 -20.519531 C 12.40625 -20.996094 10.976562 -21.546875 9.105469 -21.546875 C 6.679688 -21.546875 4.039062 -20.226562 3.046875 -17.398438 L -0.402344 -7.527344 C -0.625 -6.863281 -0.769531 -6.203125 -0.769531 -5.542969 C -0.769531 -2.496094 1.6875 0 4.917969 0 C 6.644531 0 8.40625 -0.769531 9.765625 -1.980469 C 10.941406 -0.292969 13.546875 0 14.648438 0 C 17.695312 0 21.769531 -1.542969 24.117188 -7.488281 C 24.632812 -8.921875 25.035156 -9.839844 25.035156 -10.5 C 25.035156 -11.746094 24.082031 -12.40625 23.015625 -12.40625 Z M 10.902344 -12.773438 L 9.140625 -7.304688 C 8.371094 -4.917969 6.976562 -4.367188 6.203125 -4.367188 C 5.394531 -4.367188 4.992188 -4.882812 4.992188 -5.726562 C 4.992188 -6.203125 5.101562 -6.644531 5.210938 -6.976562 L 7.5625 -14.351562 C 8.257812 -16.59375 9.289062 -16.886719 9.875 -16.886719 C 10.574219 -16.886719 11.34375 -16.1875 11.34375 -14.941406 C 11.34375 -14.390625 11.195312 -13.691406 10.902344 -12.773438 Z M 10.902344 -12.773438 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8a7b2",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.381514, 134.277632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.597656 -17.179688 L -6.203125 10.425781 C -6.351562 10.828125 -6.425781 11.234375 -6.425781 11.601562 C -6.425781 13.140625 -5.140625 14.132812 -3.78125 14.132812 C -2.644531 14.132812 -1.46875 13.4375 -0.882812 11.710938 L 9.25 -17.179688 L 11.929688 -17.214844 C 13.65625 -17.253906 14.464844 -18.5 14.464844 -19.566406 C 14.464844 -20.59375 13.691406 -21.546875 12.335938 -21.546875 L 10.828125 -21.546875 L 12.886719 -27.3125 C 13.179688 -28.191406 13.875 -28.742188 14.5 -28.742188 C 15.269531 -28.742188 15.566406 -28.304688 15.566406 -27.679688 C 15.566406 -27.457031 15.527344 -27.238281 15.453125 -26.980469 C 15.269531 -26.613281 15.199219 -26.285156 15.199219 -25.953125 C 15.199219 -24.667969 16.445312 -23.789062 17.730469 -23.789062 C 18.90625 -23.789062 20.117188 -24.523438 20.519531 -26.320312 C 20.628906 -26.835938 20.703125 -27.3125 20.703125 -27.789062 C 20.703125 -31.019531 18.207031 -33.441406 15.015625 -33.441406 C 11.894531 -33.441406 8.773438 -31.679688 7.414062 -27.863281 L 5.175781 -21.546875 L 4.222656 -21.546875 C 1.945312 -21.546875 0.992188 -20.265625 0.992188 -19.089844 C 0.992188 -18.0625 1.6875 -17.179688 2.828125 -17.179688 Z M 3.597656 -17.179688 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8a7b2",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.128146, 134.277632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.105469 -10.351562 C 11.636719 -6.3125 9.324219 -4.367188 7.195312 -4.367188 C 5.875 -4.367188 5.066406 -5.175781 5.066406 -6.167969 C 5.066406 -6.425781 5.140625 -6.71875 5.210938 -6.976562 L 8.808594 -17.214844 L 11.195312 -17.214844 C 13.070312 -17.214844 14.058594 -18.539062 14.058594 -19.75 C 14.058594 -20.703125 13.4375 -21.546875 12.039062 -21.546875 L 10.390625 -21.546875 L 12.847656 -28.707031 C 12.921875 -28.964844 12.957031 -29.183594 12.957031 -29.40625 C 12.957031 -30.761719 12.003906 -31.863281 10.390625 -31.863281 C 9.175781 -31.863281 8.148438 -31.019531 7.710938 -29.734375 L 4.773438 -21.546875 L 3.230469 -21.546875 C 1.25 -21.546875 0.402344 -20.300781 0.402344 -19.125 C 0.402344 -18.097656 1.027344 -17.214844 2.019531 -17.214844 L 3.230469 -17.214844 L 0.148438 -8.371094 L 0.148438 -8.40625 C -0.148438 -7.527344 -0.292969 -6.71875 -0.292969 -5.945312 C -0.292969 -2.203125 3.046875 0 6.828125 0 C 11.527344 0 15.453125 -3.488281 17.546875 -9.507812 C 17.621094 -9.765625 17.695312 -10.023438 17.695312 -10.242188 C 17.695312 -11.34375 16.628906 -12.039062 15.492188 -12.039062 C 14.574219 -12.039062 13.546875 -11.527344 13.105469 -10.351562 Z M 13.105469 -10.351562 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7a1240370a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.688348, 0, 0, 0.688348, 102.173925, 90.665977)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.047667 44.998558 C 25.54507 51.768621 19.892948 54.333641 15.625481 54.333641 C 11.420438 54.333641 7.249444 51.819695 7.249444 48.30698 C 7.249444 47.512505 7.357266 46.598858 7.68073 45.690887 L 14.39972 26.980998 C 15.676555 23.451259 17.861361 22.917826 19.138196 22.917826 C 20.375307 22.917826 21.220856 23.672577 21.220856 25.272877 C 21.220856 26.016279 21.016562 26.980998 20.585276 28.047865 C 20.426381 28.411053 20.375307 28.791267 20.375307 29.165805 C 20.375307 31.027146 22.185576 32.576373 24.268235 32.576373 C 26.129577 32.576373 28.212237 31.299538 29.176957 27.775473 C 29.540145 26.390817 29.69904 25.102632 29.69904 23.984692 C 29.69904 18.122601 25.062711 14.712033 18.984976 14.712033 C 15.092048 14.712033 9.059712 16.318008 6.239326 24.308157 L -0.42859 43.347185 C -1.013097 44.998558 -1.325212 46.808827 -1.325212 48.409127 C -1.325212 55.400507 5.064637 61.001557 14.348646 61.001557 C 21.754289 61.001557 30.987225 57.210776 34.295646 46.757753 C 34.397793 46.337816 34.448866 45.963278 34.448866 45.634139 C 34.448866 43.772797 32.797493 42.70593 31.14612 42.70593 C 29.761463 42.70593 28.422205 43.398259 28.047667 44.998558 Z M 53.119031 45.531992 C 51.087445 50.764178 48.369205 54.657106 46.12765 54.657106 C 45.384248 54.657106 45.00971 53.953428 45.00971 53.215701 C 45.00971 52.886561 45.060784 52.472299 45.214004 52.041013 L 48.369205 43.290437 C 48.69267 42.22357 48.902638 41.258851 48.902638 40.362229 C 48.902638 35.300287 42.507114 33.16088 39.516482 32.252908 C 39.669703 31.821622 39.7378 31.350611 39.7378 30.925 C 39.7378 28.462127 37.547319 26.390817 35.141195 26.390817 C 32.003018 26.390817 30.124652 29.165805 30.124652 32.201835 C 30.124652 33.541093 30.607012 34.920074 31.469585 35.986941 L 27.576657 46.496711 C 27.457485 46.927998 27.406412 47.34226 27.406412 47.665725 C 27.406412 49.42492 28.796743 50.338566 30.294897 50.338566 C 31.7817 50.338566 33.330926 49.475993 33.966506 47.773546 L 36.962812 39.777722 C 38.443941 40.260082 40.424454 40.623271 40.424454 42.444889 C 40.424454 42.70593 40.373381 43.03507 40.271234 43.398259 L 37.910508 49.90728 C 37.496246 51.133041 37.274928 52.250981 37.274928 53.317848 C 37.274928 57.965527 40.957887 61.001557 45.384248 61.001557 C 51.195266 61.001557 56.478526 55.831794 59.616702 46.808827 C 59.735874 46.496711 59.786947 46.22432 59.786947 45.963278 C 59.786947 44.362978 58.016402 43.290437 56.308281 43.290437 C 54.929299 43.290437 53.601391 43.931692 53.119031 45.531992 Z M 84.73914 42.978322 C 83.240987 42.978322 81.600963 43.880619 80.948359 45.912205 C 78.877048 52.472299 75.517554 54.657106 73.111429 54.657106 C 72.209133 54.657106 71.675699 54.174746 71.675699 53.317848 C 71.675699 52.886561 71.783521 52.353128 71.936741 51.768621 L 77.912329 34.488788 C 78.122297 33.853208 78.224444 33.268701 78.224444 32.735268 C 78.224444 30.391566 76.312029 29.165805 74.331516 29.165805 C 72.850387 29.165805 71.301161 29.858133 70.438588 31.186041 C 69.320648 30.493713 67.249338 29.699238 64.531098 29.699238 C 61.001359 29.699238 57.170854 31.611653 55.729449 35.71455 L 50.712906 50.0605 C 50.389442 51.02522 50.179473 51.989939 50.179473 52.954659 C 50.179473 57.369671 53.748936 61.001557 58.447689 61.001557 C 60.950285 61.001557 63.515305 59.877942 65.495818 58.124422 C 67.198265 60.57027 70.972021 61.001557 72.577996 61.001557 C 77.004357 61.001557 82.928871 58.760002 86.33944 50.117248 C 87.082841 48.045938 87.667348 46.70668 87.667348 45.75331 C 87.667348 43.931692 86.288366 42.978322 84.73914 42.978322 Z M 67.147191 42.444889 L 64.582172 50.389639 C 63.464232 53.851281 61.432645 54.657106 60.309031 54.657106 C 59.140017 54.657106 58.555511 53.902354 58.555511 52.682268 C 58.555511 51.989939 58.708731 51.354359 58.878975 50.871999 L 62.289543 40.140911 C 63.305337 36.900587 64.79214 36.469301 65.649038 36.469301 C 66.664831 36.469301 67.782771 37.485094 67.782771 39.295362 C 67.782771 40.089837 67.561453 41.105631 67.147191 42.444889 Z M 84.517822 36.038014 L 70.291043 76.141982 C 70.069725 76.726489 69.961903 77.31667 69.961903 77.850104 C 69.961903 80.085983 71.840269 81.533063 73.803758 81.533063 C 75.455131 81.533063 77.163252 80.51727 78.02015 78.014673 L 92.734964 36.038014 L 96.627892 35.986941 C 99.141838 35.935868 100.310852 34.125599 100.310852 32.576373 C 100.310852 31.07822 99.192912 29.699238 97.212399 29.699238 L 95.027592 29.699238 L 98.023898 21.328875 C 98.43816 20.040691 99.453953 19.246216 100.3676 19.246216 C 101.48554 19.246216 101.916826 19.881796 101.916826 20.795442 C 101.916826 21.107557 101.860078 21.431022 101.746582 21.794211 C 101.48554 22.333319 101.383393 22.810004 101.383393 23.292364 C 101.383393 25.153706 103.187986 26.447565 105.055003 26.447565 C 106.757449 26.447565 108.527994 25.375024 109.112501 22.758931 C 109.271396 22.015529 109.373542 21.328875 109.373542 20.625198 C 109.373542 15.937795 105.753006 12.42508 101.105327 12.42508 C 96.576819 12.42508 92.042636 14.973075 90.067798 20.523051 L 86.821799 29.699238 L 85.431468 29.699238 C 82.123047 29.699238 80.744065 31.56058 80.744065 33.268701 C 80.744065 34.766854 81.748508 36.038014 83.399882 36.038014 Z M 115.400203 45.963278 C 113.26647 51.819695 109.906976 54.657106 106.819872 54.657106 C 104.890433 54.657106 103.72142 53.476743 103.72142 52.041013 C 103.72142 51.666474 103.823566 51.235188 103.942738 50.871999 L 109.163574 35.986941 L 112.625215 35.986941 C 115.34913 35.986941 116.790535 34.074526 116.790535 32.303981 C 116.790535 30.925 115.882563 29.699238 113.850977 29.699238 L 111.456202 29.699238 L 115.037015 19.297289 C 115.139162 18.917076 115.190235 18.604961 115.190235 18.281496 C 115.190235 16.318008 113.799904 14.712033 111.456202 14.712033 C 109.697007 14.712033 108.198854 15.937795 107.563274 17.799136 L 103.290133 29.699238 L 101.048578 29.699238 C 98.171444 29.699238 96.951357 31.509506 96.951357 33.217628 C 96.951357 34.710106 97.859328 35.986941 99.295058 35.986941 L 101.048578 35.986941 L 96.571144 48.840413 L 96.571144 48.78934 C 96.156882 50.0605 95.935564 51.235188 95.935564 52.353128 C 95.935564 57.795282 100.793211 61.001557 106.286439 61.001557 C 113.107575 61.001557 118.810772 55.933941 121.858151 47.183365 C 121.960298 46.808827 122.068119 46.445638 122.068119 46.116498 C 122.068119 44.516199 120.513218 43.511755 118.873195 43.511755 C 117.533937 43.511755 116.035784 44.255157 115.400203 45.963278 Z M 115.400203 45.963278 ",
    stroke: "#f0536a",
    strokeWidth: 1.999999,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipCraftThumbnail);
export default __webpack_public_path__ + "static/media/Clip_Craft_Thumbnail.c5246b9db58b9060a3d93ab9b8bf8f88.svg";
export { ForwardRef as ReactComponent };